import $ from 'jquery'

let mouseX, mouseY
$(document).mousemove(function (e) {
  mouseX = e.pageX
  mouseY = e.pageY
})

// Tabellen auf Seitenbreite beschränken (Mobil)
$('table').wrap('<div class="table-container"></div>')

// Team Fullscreen
let teamMember
let teamFullscreen
let actualTeamMember
$(window).ready(function () {
  teamMember = $('.team-member')
  teamFullscreen = $('.team-fullscreen')
  for (var i = 0; i < teamMember.length; i++) {
    teamMember[i].addEventListener('click', function () {
      actualTeamMember = teamMember.index($(this))
      $(teamFullscreen[actualTeamMember]).removeClass('hidden')
    })
  }
  for (var i = 0; i < teamFullscreen.length; i++) {
    teamFullscreen[i].addEventListener('click', function () {
      $(this).addClass('hidden')
    })
    $('.team-item')[i].addEventListener('click', function (event) {
      event.stopPropagation()
    })
  }

  //Previous & Next
  const previousButtons = $('.team-fullscreen .previous')
  Array.from(previousButtons).forEach(function (b) {
    b.addEventListener('click', function () {
      previousTeamMember()
    })
  })
  const nextButtons = $('.team-fullscreen .next')
  Array.from(nextButtons).forEach(function (b) {
    b.addEventListener('click', function () {
      nextTeamMember()
    })
  })
  function previousTeamMember() {
    $(teamFullscreen[actualTeamMember]).addClass('hidden')
    actualTeamMember -= 1
    if (actualTeamMember < 0) actualTeamMember = teamMember.length - 1
    $(teamFullscreen[actualTeamMember]).removeClass('hidden')
  }
  function nextTeamMember() {
    $(teamFullscreen[actualTeamMember]).addClass('hidden')
    actualTeamMember += 1
    if (actualTeamMember >= teamMember.length) actualTeamMember = 0
    $(teamFullscreen[actualTeamMember]).removeClass('hidden')
  }

  //Arrow keys
  document.addEventListener('keydown', (event) => {
    if ($('.team-fullscreen').length > $('.team-fullscreen.hidden').length) {
      switch (event.key) {
        case 'Escape': // ESC
          $($(".team-fullscreen:not('.hidden')")).addClass('hidden')
          break
        case 'ArrowLeft':
          previousTeamMember()
          break
        case 'ArrowRight':
          nextTeamMember()
          break
      }
    }
  })
})

// Botschafter
let actualBotschafter = 0
let botschafter, dots, botschafterContainer, botschafterAutoplay
const botschafterTime = 7500
$(window).ready(function () {
  if ($('.botschafter').length > 0) {
    botschafterContainer = $('.botschafterContainer')[0]
    botschafter = $('.botschafter')
    dots = $('#start-botschafter .dot')
    dots.click(function () {
      actualBotschafter = $(this).index()
      updateBotschafter()
      clearInterval(botschafterAutoplay)
      botschafterAutoplay = setInterval(nextBotschafter, botschafterTime)
    })
    $('#start-botschafter .next').click(function () {
      nextBotschafter()
      clearInterval(botschafterAutoplay)
      botschafterAutoplay = setInterval(nextBotschafter, botschafterTime)
    })
    $('#start-botschafter .previous').click(function () {
      previousBotschafter()
      clearInterval(botschafterAutoplay)
      botschafterAutoplay = setInterval(nextBotschafter, botschafterTime)
    })

    $('.botschafter').on('swipeleft', function () {
      nextBotschafter()
      clearInterval(botschafterAutoplay)
      botschafterAutoplay = setInterval(nextBotschafter, botschafterTime)
    })
    $('.botschafter').on('swiperight', function () {
      previousBotschafter()
      clearInterval(botschafterAutoplay)
      botschafterAutoplay = setInterval(nextBotschafter, botschafterTime)
    })

    if (botschafter.length > 0) {
      updateBotschafter()
    }
    botschafterAutoplay = setInterval(nextBotschafter, botschafterTime)
  }
})
function previousBotschafter() {
  actualBotschafter--
  updateBotschafter()
}
function nextBotschafter() {
  actualBotschafter++
  updateBotschafter()
}
function updateBotschafter() {
  if (actualBotschafter >= botschafter.length) {
    actualBotschafter = 0
  }
  if (actualBotschafter < 0) {
    actualBotschafter = botschafter.length - 1
  }
  $(dots).each(function () {
    if (this == dots[actualBotschafter]) {
      if (!$(this).hasClass('current')) $(this).addClass('current')
    } else {
      if ($(this).hasClass('current')) $(this).removeClass('current')
    }
  })
  $(botschafter).each(function () {
    if (this == botschafter[actualBotschafter]) {
      $(this).css('opacity', 1)
    } else {
      $(this).css('opacity', 0)
    }
  })
  let offset = $($('.botschafter')[actualBotschafter]).offset().left
  if (window.innerWidth > 750) {
    offset -= $('#menu').outerWidth()
    // console.log('desktop')
  }
  botschafterContainer.scrollLeft += offset
}
$(window).resize(function () {
  if ($('.botschafter').length > 0) {
    updateBotschafter()
  }
})

// Searching Animation
$(window).ready(function () {
  $('.search-button').click(function () {
    showSearching()
  })
})
function showSearching() {
  $('#searching').css('display', 'flex')
  $('#searching').hide()
  $('#searching').fadeIn(500)
}

// Button .close
$(window).ready(function () {
  $('button.close').click(function () {
    $(this).parent().addClass('hidden')
  })

  // Enable Submittbutton
  $('.enable-submit-button').click(function () {
    const submitButton = $(this).next()
    $(this).addClass('hidden')
    $(this).closest('form').addClass('--validate')
    $(submitButton).replaceWith(
      "<input type='submit' name='" +
        $(submitButton).attr('name') +
        "' value='" +
        $(submitButton).attr('value') +
        "'>",
    )
  })
})

// Facts
let randomFacts
let refreshButton
let lastActiveFact
let rotationFacts = 0
$(window).ready(function () {
  if (document.querySelector('.random-fact')) {
    randomFacts = $('.random-fact')
    refreshButton = $('#random-fact-refresh')
    refreshButtonIcon = $('#random-fact-refresh i')[0]
    refreshButton.click(function () {
      generateFact()
    })
    refreshButton.hover(
      function () {
        rotationFacts += 45
        $(refreshButtonIcon).css('transform', 'rotate(' + rotationFacts + 'deg)')
      },
      function () {
        rotationFacts -= 45
        $(refreshButtonIcon).css('transform', 'rotate(' + rotationFacts + 'deg)')
      },
    )
    generateFact()
  }
})

function generateFact() {
  rotationFacts += 180
  let activeFact
  if (randomFacts.length > 1) {
    do {
      activeFact = Math.floor(Math.random() * randomFacts.length)
    } while (lastActiveFact == activeFact)
    lastActiveFact = activeFact
    randomFacts.each(function (index) {
      $(this).hide()
      $(this).css('transform', 'translateY(20px)')
      $(this).css('transition', 'transform 0.7s ease-out')
      if (index == activeFact) {
        $(this).fadeIn(700)
        $(this).css('display', 'flex')
        $(this).css('transform', 'translateY(0px)')
      }
    })
  }
  $(refreshButtonIcon).css('transform', 'rotate(' + rotationFacts + 'deg)')
}

// Menu onscroll minimieren
// Link nach oben einblenden

const topVideo = false

let pScroll = 0
$(window).scroll(function (event) {
  const scroll = $(window).scrollTop()

  // Back to Top
  const totop = $('#totop')
  if (scroll > 0) {
    totop.css('opacity', '1')
    totop.css('transform', 'translateY(0px)')
  } else {
    totop.css('opacity', '0')
    totop.css('transform', 'translateY(5px)')
  }

  pScroll = scroll
})
$(window).ready(function () {
  const totop = $('#totop')
  totop.click(function () {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  })
})

// Events
$(window).ready(function () {
  const outdated = $('.outdated')
  const outdatedEventsButton = $('button.outdated-events')
  if (outdated.length > 0) {
    outdatedEventsButton.css('display', 'flex')
  }
  outdatedEventsButton.click(function () {
    if (outdated.css('display') == 'none') {
      outdated.css('display', 'flex')
      outdatedEventsButton.text('Vergangene Veranstaltungen ausblenden')
    } else {
      outdated.css('display', 'none')
      outdatedEventsButton.text('Vergangene Veranstaltungen anzeigen')
    }
  })
})

// Home Titlevideo
if ($('#title-video video').length > 0) {
  $('#title-video video')[0].playbackRate = 0.9
  $('#title-video-play-button').click(function (e) {
    if ($('#title-video-play-button').text() === '') {
      $('#title-video-play-button').text('')
      $('#title-video-play-button').attr('aria-label', 'Video fortsetzen')
      $('#title-video video')[0].pause()
    } else {
      $('#title-video-play-button').text('')
      $('#title-video-play-button').attr('aria-label', 'Video pausieren')
      $('#title-video video')[0].play()
    }
  })
}

// Footer intro-videos
let actualIntroVideo = 0
if ($('#intro-video').length > 0) {
  $('#intro-video-start-button').click(function (e) {
    $('#intro-video').addClass('active')
    $('#intro-video-start-button').addClass('hidden')
    $($('#intro-video video')[actualIntroVideo]).parent().removeClass('hidden')
    $($('#intro-video video')[actualIntroVideo]).removeClass('hidden')
    $('#intro-video video')[actualIntroVideo].play()
    $('#intro-video-pause-button').text('')
  })

  $('#intro-video-close-button').click(function (e) {
    $('#intro-video video')[actualIntroVideo].pause()
    $('#intro-video video')[actualIntroVideo].currentTime = 0
    $('#intro-video-pause-button').text('')
    $('#intro-video').removeClass('active')
    $('#intro-video-start-button').removeClass('hidden')
    $($('#intro-video video')[actualIntroVideo]).parent().addClass('hidden')
  })

  $('#intro-video-restart-button').click(function (e) {
    $('#intro-video video')[actualIntroVideo].currentTime = 0
    $('#intro-video-pause-button').text('')
    if ($('#intro-video video')[actualIntroVideo].paused) {
      $('#intro-video video')[actualIntroVideo].play()
    }
  })

  $('#intro-video-pause-button').click(function (e) {
    if ($('#intro-video video')[actualIntroVideo].paused) {
      $('#intro-video video')[actualIntroVideo].play()
      $('#intro-video-pause-button').text('')
    } else {
      $('#intro-video video')[actualIntroVideo].pause()
      $('#intro-video-pause-button').text('')
    }
  })

  if ($('#intro-video-previous-button')) {
    $('#intro-video-previous-button').click(function (e) {
      // Stop
      $($('#intro-video video')[actualIntroVideo]).addClass('hidden')
      $('#intro-video video')[actualIntroVideo].pause()
      $('#intro-video video')[actualIntroVideo].currentTime = 0
      // Next
      actualIntroVideo--
      if (actualIntroVideo < 0) {
        actualIntroVideo = $('#intro-video video').length - 1
      }
      $($('#intro-video video')[actualIntroVideo]).removeClass('hidden')
      $('#intro-video video')[actualIntroVideo].play()
      $('#intro-video-pause-button').text('')
    })
  }
  if ($('#intro-video-next-button')) {
    $('#intro-video-next-button').click(function (e) {
      // Stop
      $($('#intro-video video')[actualIntroVideo]).addClass('hidden')
      $('#intro-video video')[actualIntroVideo].pause()
      $('#intro-video video')[actualIntroVideo].currentTime = 0
      // Next
      actualIntroVideo++
      if (actualIntroVideo >= $('#intro-video video').length) {
        actualIntroVideo = 0
      }
      $($('#intro-video video')[actualIntroVideo]).removeClass('hidden')
      $('#intro-video video')[actualIntroVideo].play()
      $('#intro-video-pause-button').text('')
    })
  }

  document.querySelectorAll('#intro-video video').forEach((v) => {
    v.addEventListener('ended', (event) => {
      actualIntroVideo++
      if (actualIntroVideo >= $('#intro-video video').length) {
        actualIntroVideo = 0
        $('#intro-video-pause-button').text('')
      } else {
        $(v).addClass('hidden')
        $($('#intro-video video')[actualIntroVideo]).removeClass('hidden')
        $('#intro-video video')[actualIntroVideo].play()
      }
    })
    v.addEventListener('timeupdate', (event) => {
      const circle = document.querySelector('#intro-video-progressring')
      const radius = circle.r.baseVal.value
      const circumference = radius * 2 * Math.PI
      circle.style.strokeDasharray = `${circumference} ${circumference}`
      circle.style.strokeDashoffset = `${circumference}`
      const progress = v.currentTime / v.duration

      const offset = circumference - progress * circumference
      circle.style.strokeDashoffset = offset
    })
  })
}